module.exports = __webpack_public_path__ + "img/about-us-banner.8f1975c1.png";